/* Silk Pillowcase Page - Native JS (replaces Replo runtime)
 * Fixed: 2026-02-23 — pricing, variant selection, cart math */
(function() {
  'use strict';

  var productData = null;
  var shopData = null;

  /* === COLOR NAME MAPPING ===
   * Hero section uses marketing display names; variants use product option names.
   * This map normalizes display → variant option1 values. */
  var colorMap = {
    'White Silk': 'Cream Silk',
    'Champagne Silk': 'Caramel Silk'
  };
  function normalizeColor(displayName) {
    return colorMap[displayName] || displayName;
  }

  /* === LOAD PRODUCT DATA === */
  function loadProductData() {
    var el = document.getElementById('replo-deps-products');
    if (el) {
      try {
        var arr = JSON.parse(el.textContent);
        if (arr && arr[0]) productData = arr[0].data;
      } catch(e) { console.error('Failed to parse product data:', e); }
    }
    var shopEl = document.getElementById('replo-deps-shopify-store');
    if (shopEl) {
      try {
        shopData = JSON.parse(shopEl.textContent);
      } catch(e) {}
    }
  }

  /* === MONEY FORMAT === */
  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    var dollars = (cents / 100).toFixed(2);
    if (shopData && shopData.shop && shopData.shop.moneyFormat) {
      return shopData.shop.moneyFormat
        .replace('{{amount}}', dollars)
        .replace('{{ amount }}', dollars);
    }
    return '$' + dollars;
  }

  /* === FIND VARIANT (all 3 options) === */
  function findVariant(color, size, qtyLabel) {
    if (!productData || !productData.variants) return null;
    var normColor = normalizeColor(color);
    // Exact match on all 3 options
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      if (v.option1 === normColor && v.option2 === size && v.option3 === qtyLabel) return v;
    }
    // Fallback: color + size only (returns first match = 1 Pillowcase)
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      if (v.option1 === normColor && v.option2 === size) return v;
    }
    return null;
  }

  /* === EXTRACT TEXT from option element === */
  function getOptionText(optionEl) {
    if (!optionEl) return '';
    var rte = optionEl.querySelector('.alchemy-rte');
    if (!rte) return optionEl.textContent.trim();
    // Try <p> first, then fall back to direct text content
    var p = rte.querySelector('p');
    if (p) return p.textContent.trim();
    // Bare <span> text (e.g., "Silver Silk")
    var span = rte.querySelector('span');
    if (span) return span.textContent.trim();
    return rte.textContent.trim();
  }

  /* === QUANTITY LABEL from tier number === */
  function qtyLabel(n) {
    return n === 1 ? '1 Pillowcase' : n + ' Pillowcases';
  }

  /* === GET SELECTED OPTION VALUE === */
  function getSelectedInGroup(container, type) {
    var selects = container.querySelectorAll('[data-replo-option-select="true"]');
    for (var i = 0; i < selects.length; i++) {
      var selected = selects[i].querySelector('[role="option"][aria-selected="true"]');
      if (!selected) continue;
      var text = getOptionText(selected);
      if (!text) continue;

      if (type === 'color' && !/Queen|King|Standard|Pillowcase/i.test(text)) return text;
      if (type === 'size' && /Queen|King|Standard/i.test(text)) return text;
      if (type === 'quantity' && /Pillowcase/i.test(text)) return text;
    }
    return null;
  }

  /* === PARSE QTY from text like "2 Pillowcases" === */
  function parseQty(text) {
    if (!text) return 1;
    var m = text.match(/(\d+)/);
    return m ? parseInt(m[1]) : 1;
  }

  /* === UPDATE HERO PRICING ===
   * Updates: total price display, save % badge, per-unit prices on qty tiers, save badges */
  function updateHeroPricing(container, color, size, qtyText) {
    var qty = parseQty(qtyText);
    var bundleVariant = findVariant(color, size, qtyLabel(qty));
    var singleVariant = findVariant(color, size, '1 Pillowcase');

    if (!bundleVariant) return;

    var totalPrice = bundleVariant.price;
    var singlePrice = singleVariant ? singleVariant.price : totalPrice;
    var perUnit = Math.round(totalPrice / qty);
    var fullPriceTotal = singlePrice * qty;
    var savings = fullPriceTotal - totalPrice;

    // Update main price display (data-replo-price)
    var priceEl = container.querySelector('[data-replo-price]');
    if (priceEl) {
      var span = priceEl.querySelector('span');
      if (span) span.textContent = formatMoney(totalPrice);
      priceEl.setAttribute('data-variant-id', bundleVariant.id);
    }

    // Update "Save X%" badge near the price
    // The save % is based on compare_at_price or MSRP. Since variants don't have compare_at,
    // calculate: savings / fullPriceTotal * 100. Use single × qty as the "full price".
    var savePercentEl = container.querySelector('[data-rid="0138c717-b3fe-4d09-aaca-ea71c85abb1b"]');
    if (!savePercentEl) {
      // Try finding by content pattern
      var rtes = container.querySelectorAll('.alchemy-rte');
      for (var i = 0; i < rtes.length; i++) {
        if (/Save \d+%/.test(rtes[i].textContent)) {
          savePercentEl = rtes[i];
          break;
        }
      }
    }
    if (savePercentEl && savings > 0) {
      var pct = Math.round((savings / fullPriceTotal) * 100);
      var pEl = savePercentEl.querySelector('p');
      if (pEl) pEl.textContent = 'Save ' + pct + '%';
      else savePercentEl.querySelector('span').textContent = 'Save ' + pct + '%';
      savePercentEl.closest('[data-rid]').style.display = '';
    } else if (savePercentEl && savings <= 0) {
      // Hide save badge for single item
      var badge = savePercentEl.closest('[data-rid]');
      if (badge && badge.parentElement && badge.parentElement !== container) {
        badge.style.display = 'none';
      }
    }

    // Update form hidden inputs
    var form = container.querySelector('form');
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = bundleVariant.id;
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) qtyInput.value = '1'; // Always 1 — variant IS the bundle
    }

    // Update per-unit prices and save badges on each quantity tier option
    updateQtyTierDisplays(container, color, size, singlePrice);
  }

  /* === UPDATE QTY TIER DISPLAYS in hero === */
  function updateQtyTierDisplays(container, color, size, singlePrice) {
    // Find the quantity option-select
    var selects = container.querySelectorAll('[data-replo-option-select="true"]');
    var qtySelect = null;
    for (var i = 0; i < selects.length; i++) {
      var opts = selects[i].querySelectorAll('[role="option"]');
      for (var j = 0; j < opts.length; j++) {
        if (/Pillowcase/i.test(getOptionText(opts[j]))) {
          qtySelect = selects[i];
          break;
        }
      }
      if (qtySelect) break;
    }
    if (!qtySelect) return;

    var options = qtySelect.querySelectorAll('[role="option"]');
    options.forEach(function(opt) {
      var text = getOptionText(opt);
      var tierQty = parseQty(text);
      var tierVariant = findVariant(color, size, qtyLabel(tierQty));
      if (!tierVariant) return;

      var tierPerUnit = Math.round(tierVariant.price / tierQty);
      var tierSavings = (singlePrice * tierQty) - tierVariant.price;

      // Find the "each" price element — it's an alchemy-rte with "$XX.XX each"
      var rtes = opt.querySelectorAll('.alchemy-rte');
      rtes.forEach(function(rte) {
        var t = rte.textContent.trim();
        if (/\$[\d.]+ each/i.test(t)) {
          // Update per-unit price
          var em = rte.querySelector('em');
          var target = em || rte.querySelector('p') || rte.querySelector('span');
          if (target) target.textContent = formatMoney(tierPerUnit) + ' each';
        }
        if (/Save \$[\d.]+/.test(t)) {
          // Update save amount
          var p = rte.querySelector('p');
          var target = p || rte.querySelector('span');
          if (target) {
            if (tierSavings > 0) {
              target.textContent = 'Save ' + formatMoney(tierSavings);
            } else {
              target.textContent = '';
            }
          }
        }
      });
    });
  }

  /* === OPTION SELECTORS === */
  function initOptionSelects() {
    document.querySelectorAll('[data-replo-product-container]').forEach(function(container, containerIndex) {
      var selects = container.querySelectorAll('[data-replo-option-select="true"]');

      selects.forEach(function(listbox) {
        var options = listbox.querySelectorAll('[role="option"]');
        options.forEach(function(option) {
          option.addEventListener('click', function() {
            // Deselect all in this listbox
            options.forEach(function(o) {
              o.setAttribute('aria-selected', 'false');
            });
            // Select clicked
            option.setAttribute('aria-selected', 'true');

            // Trigger update for this container
            onContainerOptionChange(container, containerIndex);
          });
        });
      });
    });
  }

  /* === HANDLE ANY OPTION CHANGE === */
  function onContainerOptionChange(container, containerIndex) {
    var color = getSelectedInGroup(container, 'color');
    var size = getSelectedInGroup(container, 'size');
    var qtyText = getSelectedInGroup(container, 'quantity');

    if (containerIndex === 0) {
      // Hero section — has all 3 selectors
      if (!size) size = 'Queen';
      if (!qtyText) qtyText = '2 Pillowcases';
      if (!color) color = 'Silver Silk';
      updateHeroPricing(container, color, size, qtyText);
    } else {
      // Bundle section card — has color + size selectors, fixed qty
      var bundleQty = getBundleCardQty(container);
      if (!size) size = 'Queen';
      if (!color) color = 'Silver Silk';
      updateBundleCard(container, color, size, bundleQty);
    }
  }

  /* === GET BUNDLE CARD QUANTITY === */
  function getBundleCardQty(container) {
    // Bundle cards have a fixed qty in their form
    var form = container.querySelector('form');
    if (form) {
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) {
        var val = parseInt(qtyInput.getAttribute('data-original-qty') || qtyInput.value);
        return val || 2;
      }
    }
    return 2;
  }

  /* === UPDATE BUNDLE CARD === */
  function updateBundleCard(container, color, size, qty) {
    var bundleVariant = findVariant(color, size, qtyLabel(qty));
    var singleVariant = findVariant(color, size, '1 Pillowcase');

    if (!bundleVariant) return;

    var totalPrice = bundleVariant.price;
    var singlePrice = singleVariant ? singleVariant.price : totalPrice;
    var perUnit = Math.round(totalPrice / qty);
    var savings = (singlePrice * qty) - totalPrice;

    // Update form: use bundle variant, qty=1
    var form = container.querySelector('form');
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = bundleVariant.id;
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) qtyInput.value = '1';
    }

    // Update price displays in this card
    var priceEl = container.querySelector('[data-replo-price]');
    if (priceEl) {
      var span = priceEl.querySelector('span');
      if (span) span.textContent = formatMoney(totalPrice);
    }

    // Update per-unit and savings text
    var rtes = container.querySelectorAll('.alchemy-rte');
    rtes.forEach(function(rte) {
      var t = rte.textContent.trim();
      if (/\$[\d.]+ each/i.test(t)) {
        var em = rte.querySelector('em');
        var target = em || rte.querySelector('p') || rte.querySelector('span');
        if (target) target.textContent = formatMoney(perUnit) + ' each';
      }
      if (/Save \$[\d.]+/.test(t) && !/Save \d+%/.test(t)) {
        var p = rte.querySelector('p');
        var target = p || rte.querySelector('span');
        if (target) target.textContent = savings > 0 ? 'Save ' + formatMoney(savings) : '';
      }
      // Strikethrough original price
      if (/^\$[\d.]+$/.test(t) && rte.querySelector('s, del, strike')) {
        var strikeEl = rte.querySelector('s, del, strike') || rte.querySelector('span');
        if (strikeEl) strikeEl.textContent = formatMoney(singlePrice * qty);
      }
    });
  }

  /* === INITIALIZE BUNDLE CARDS ===
   * Store original qty and set correct variant on page load */
  function initBundleCards() {
    var containers = document.querySelectorAll('[data-replo-product-container]');
    containers.forEach(function(container, i) {
      if (i === 0) return; // Skip hero

      var form = container.querySelector('form');
      if (!form) return;
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) {
        // Store original bundle qty as data attribute
        qtyInput.setAttribute('data-original-qty', qtyInput.value);
      }

      // Get defaults and set correct variant
      var color = getSelectedInGroup(container, 'color') || 'Silver Silk';
      var size = getSelectedInGroup(container, 'size') || 'Queen';
      var qty = getBundleCardQty(container);

      updateBundleCard(container, color, size, qty);
    });
  }

  /* === FAQ ACCORDION === */
  function initCollapsibles() {
    document.querySelectorAll('[data-replo-collapsible="true"]').forEach(function(collapsible) {
      var trigger = collapsible.querySelector('[role="button"]');
      if (!trigger) return;

      var contentId = trigger.getAttribute('aria-controls');
      var content = contentId ? document.getElementById(contentId) : null;
      if (!content) {
        content = collapsible.querySelector('[hidden]');
      }
      if (!content) return;

      trigger.addEventListener('click', function() {
        var isOpen = collapsible.getAttribute('data-state') === 'open';
        collapsible.setAttribute('data-state', isOpen ? 'closed' : 'open');
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (isOpen) {
          content.setAttribute('hidden', '');
        } else {
          content.removeAttribute('hidden');
        }
        var svg = trigger.querySelector('svg');
        if (svg) {
          svg.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(45deg)';
          svg.style.transition = 'transform 0.2s ease';
        }
      });

      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    });
  }

  /* === CAROUSELS === */
  function initCarousels() {
    document.querySelectorAll('[data-replo-carousel="true"]').forEach(function(carousel) {
      var track = carousel.querySelector('[data-replo-part="slide-track"]');
      var slides = Array.from(carousel.querySelectorAll('[data-replo-part="slide"]'));
      var prevBtn = carousel.querySelector('[data-direction="previous"]');
      var nextBtn = carousel.querySelector('[data-direction="next"]');

      if (!track || slides.length === 0) return;

      var parent = carousel.closest('[data-rid]');
      var dots = [];
      if (parent && parent.parentElement) {
        dots = Array.from(parent.parentElement.querySelectorAll('[aria-label^="Go to slide"]'));
      }
      if (dots.length === 0) {
        var next = carousel.parentElement;
        while (next) {
          dots = Array.from(next.querySelectorAll('[aria-label^="Go to slide"]'));
          if (dots.length > 0) break;
          next = next.parentElement;
        }
      }

      var slidesPerPage = parseInt(getComputedStyle(track).getPropertyValue('--replo-carousel-slides-per-page')) || 1;

      var sourceIndices = [];
      slides.forEach(function(s) {
        var idx = parseInt(s.getAttribute('data-slide-source-index'));
        if (!isNaN(idx) && sourceIndices.indexOf(idx) === -1) {
          sourceIndices.push(idx);
        }
      });
      var totalSlides = sourceIndices.length || slides.length;

      var currentIndex = 0;
      var isAnimating = false;

      function goToSlide(index) {
        if (isAnimating) return;
        if (index < 0) index = totalSlides - 1;
        if (index >= totalSlides) index = 0;
        currentIndex = index;
        isAnimating = true;

        var slideWidth = 100 / slidesPerPage;
        var offset = -(index * slideWidth);
        track.style.transitionDuration = '400ms';
        track.style.transitionProperty = 'transform';
        track.style.transform = 'translate3d(' + offset + '%, 0px, 0px)';

        setTimeout(function() { isAnimating = false; }, 450);

        dots.forEach(function(dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });

        slides.forEach(function(s) {
          var srcIdx = parseInt(s.getAttribute('data-slide-source-index'));
          var isActive = srcIdx === index;
          s.setAttribute('data-is-active', isActive ? 'true' : 'false');
          s.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
      }

      if (prevBtn) {
        prevBtn.disabled = false;
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          goToSlide(currentIndex - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          goToSlide(currentIndex + 1);
        });
      }

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goToSlide(i); });
      });

      goToSlide(0);
    });
  }

  /* === ADD TO CART === */
  function initAddToCart() {
    document.querySelectorAll('[data-replo-add-product-variant-to-cart]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var container = btn.closest('[data-replo-product-container]');
        if (!container) return;

        var form = container.querySelector('form');
        if (!form) return;

        var variantId = form.querySelector('input[name="id"]');
        var quantity = form.querySelector('input[name="quantity"]');
        var sellingPlan = form.querySelector('input[name="selling_plan"]');

        if (!variantId || !variantId.value) {
          console.error('No variant ID set');
          alert('Please select your options first.');
          return;
        }

        var body = {
          id: parseInt(variantId.value),
          quantity: parseInt(quantity ? quantity.value : '1') || 1
        };
        if (sellingPlan && sellingPlan.value) {
          body.selling_plan = parseInt(sellingPlan.value);
        }

        console.log('ATC:', body);

        btn.style.opacity = '0.7';
        btn.style.pointerEvents = 'none';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
        .then(function(r) {
          if (!r.ok) throw new Error('Add to cart failed: ' + r.status);
          return r.json();
        })
        .then(function(item) {
          btn.style.opacity = '1';
          btn.style.pointerEvents = '';

          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart-count').forEach(function(el) {
                el.textContent = cart.item_count;
              });
              document.querySelectorAll('.cart-count-bubble').forEach(function(el) {
                el.style.display = '';
              });
            });

          var drawerToggle = document.querySelector('[data-cart-toggle], .js-drawer-open-cart, cart-drawer');
          if (drawerToggle) {
            if (typeof drawerToggle.open === 'function') {
              drawerToggle.open();
            } else {
              drawerToggle.click();
            }
          }

          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: item } }));
        })
        .catch(function(err) {
          console.error('ATC error:', err);
          btn.style.opacity = '1';
          btn.style.pointerEvents = '';
          alert('Could not add to cart. Please try again.');
        });
      });
    });
  }

  /* === SCROLL-TO BUTTONS === */
  function initScrollButtons() {
    document.querySelectorAll('button[role="link"]').forEach(function(btn) {
      var text = (btn.textContent || '').trim().toLowerCase();
      if (text.includes('try it out') || text.includes('order now')) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var hero = document.querySelector('[data-replo-product-container]');
          if (hero) {
            hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      }
    });
  }

  /* === INJECT OPTION SELECT STYLES === */
  function injectOptionStyles() {
    var style = document.createElement('style');
    style.textContent = [
      '[data-replo-option-select] [role="option"][aria-selected="true"] {',
      '  background-color: #F7D9E2 !important;',
      '  border: 1.5px solid #DA7487 !important;',
      '}',
      '[data-replo-option-select] [role="option"][aria-selected="false"] {',
      '  background-color: #FFF !important;',
      '  border: 1px solid #E6E6E6 !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  /* === INIT === */
  function init() {
    injectOptionStyles();
    loadProductData();
    initCollapsibles();
    initCarousels();
    initOptionSelects();
    initAddToCart();
    initScrollButtons();

    // Set correct variants on all containers at load time
    if (productData) {
      // Hero: set variant for default selection (Silver Silk / Queen / 2 Pillowcases)
      var heroContainer = document.querySelector('[data-replo-product-container]');
      if (heroContainer) {
        var color = getSelectedInGroup(heroContainer, 'color') || 'Silver Silk';
        var size = getSelectedInGroup(heroContainer, 'size') || 'Queen';
        var qtyText = getSelectedInGroup(heroContainer, 'quantity') || '2 Pillowcases';
        updateHeroPricing(heroContainer, color, size, qtyText);
      }

      // Bundle cards: fix variant IDs
      initBundleCards();
    }
  }

  // Mobile carousel fix: force 1 slide per page at <=640px
  // Uses MutationObserver to fight Replo carousel JS that resets inline styles
  function fixMobileCarousels() {
    var mobileBreak = 640;
    function isMobile() { return window.innerWidth <= mobileBreak; }

    function patchTrack(t) {
      if (!isMobile()) return;
      var cur = t.style.getPropertyValue('--replo-carousel-slides-per-page').trim();
      if (cur && cur !== '1') {
        if (!t.getAttribute('data-desktop-spp')) t.setAttribute('data-desktop-spp', cur);
        t.style.setProperty('--replo-carousel-slides-per-page', '1');
      }
    }

    function patchAll() {
      document.querySelectorAll('[data-replo-part="slide-track"]').forEach(patchTrack);
    }

    // Observe style attribute mutations on slide tracks
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'style') {
          patchTrack(m.target);
        }
      });
    });

    function observe() {
      document.querySelectorAll('[data-replo-part="slide-track"]').forEach(function(t) {
        observer.observe(t, { attributes: true, attributeFilter: ['style'] });
      });
    }

    patchAll();
    observe();

    // Re-apply on resize
    window.addEventListener('resize', function() {
      document.querySelectorAll('[data-replo-part="slide-track"]').forEach(function(t) {
        var orig = t.getAttribute('data-desktop-spp') || '3';
        t.style.setProperty('--replo-carousel-slides-per-page', isMobile() ? '1' : orig);
      });
    });

    // Safety: re-patch after Replo might initialize (500ms, 1s, 2s)
    [500, 1000, 2000].forEach(function(d) { setTimeout(patchAll, d); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); fixMobileCarousels(); });
  } else {
    setTimeout(function() { init(); fixMobileCarousels(); }, 100);
  }
})();
